/* @flow */

export type RideInformation = {
  name: string,
  steps: Object,
}

export const AdminSignupRideInformation = {
  name: 'ride-admin-signup-onboarding',
  steps: {
    'joyride-subscribed-classes-section': {
      index: 0,
      required: true,
      title: 'Anyone can create a class',
      text: 'Teachers often create classes and add their students and parents to them, but school and district administrators can also create classes to communicate with their staff.',
      name: 'joyride-subscribed-classes-section',
      selector: '.joyride-subscribed-classes-section',
      position: 'right',
    },
    'joyride-send-a-message': {
      index: 1,
      required: true,
      title: 'Compose announcements and messages',
      text: 'You can use Remind to send announcements to the whole school or just to individual classes that you created or joined, or to start conversations with individuals or groups of people.',
      name: 'joyride-send-a-message',
      selector: '.joyride-send-a-message',
      position: 'right',
    },
    'joyride-check-out-school': {
      index: 2,
      required: false,
      title: 'Check out your school to get started',
      text: 'Once you‘re verified as an administrator of your school, you can view your school to see and send schoolwide announcements, to start conversations with anybody in your school, or to see a list of everyone in your school who‘s using Remind.',
      name: 'joyride-check-out-school',
      selector: '.joyride-check-out-school',
      position: 'right',
    },
    'joyride-check-out-district': {
      index: 2,
      required: false,
      title: 'Check out your schools to get started',
      text: 'Once you‘re verified as an administrator of your district, you can view your schools to see and send schoolwide announcements, to start conversations with anybody in your district, or to see a list of everyone in each school who‘s using Remind.',
      name: 'joyride-check-out-district',
      selector: '.joyride-check-out-district',
      position: 'right',
    },
  },
};



// WEBPACK FOOTER //
// ./src/constants/rides.js